
import Vue, { PropType } from "vue";

interface DetailItem {
  label: string;
  value: string;
}

export default Vue.extend({
  name: "AiReportInterviewDetailsCard",
  props: {
    topItems: {
      type: Array as PropType<DetailItem[]>,
      required: true
    },
    bottomItems: {
      type: Array as PropType<DetailItem[]>,
      required: true
    },
    skills: {
      type: Array as PropType<string[]>,
      required: true
    }
  }
});
